var exports = {
  "p$": "FloatingPaneResizeHandles.module__handle___aEU3cV",
  "J3": "FloatingPaneResizeHandles.module__edgeTop___aEU3cV",
  "xf": "FloatingPaneResizeHandles.module__edgeBottom___aEU3cV",
  "Ve": "FloatingPaneResizeHandles.module__edgeLeft___aEU3cV",
  "IW": "FloatingPaneResizeHandles.module__edgeRight___aEU3cV",
  "wy": "FloatingPaneResizeHandles.module__cornerTopLeft___aEU3cV",
  "Ty": "FloatingPaneResizeHandles.module__cornerTopRight___aEU3cV",
  "AU": "FloatingPaneResizeHandles.module__cornerBottomLeft___aEU3cV",
  "pr": "FloatingPaneResizeHandles.module__cornerBottomRight___aEU3cV",
};

module.exports = exports;
